import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomUnavailableProductsComponent} from './custom-unavailable-products.component';
import {CustomStockNotificationModule} from '../../../../spartacus/custom/cms-components/product/custom-stock-notification/custom-stock-notification.module';
import {EffectsModule} from '@ngrx/effects';
import {effectsUnavailableProducts} from '../../../cart/unavailable-products/store/effects/custom-unavailable-products.effect';
import {CustomAddToWishListModule} from '../../../../spartacus/custom/cms-components/cart/custom-add-to-whish-list/custom-add-to-wish-list.module';
import {RouterModule} from '@angular/router';
import {IconModule, MediaModule} from '@spartacus/storefront';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {CustomCartDetailsComponent} from '../../../../spartacus/custom/cms-components/cart/custom-cart-details/custom-cart-details.component';
import {CustomIconsModule} from '../../../icons/custom-icons.module';


@NgModule({
  declarations: [CustomUnavailableProductsComponent],
  exports: [
    CustomUnavailableProductsComponent
  ],
    imports: [
        CommonModule,
        CustomStockNotificationModule,
        EffectsModule.forFeature(effectsUnavailableProducts),
        CustomAddToWishListModule,
        RouterModule,
        MediaModule,
        I18nModule,
        IconModule,
        CustomIconsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                UnavailableComponent: {
                    component: CustomUnavailableProductsComponent,
                },
            }
        } as CmsConfig),
        UrlModule,

    ]
})
export class CustomUnavailableProductsModule {
}
